var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordian"},_vm._l((_vm.options),function(option){return _c('div',{key:option.id},[_c('accordian-item',{attrs:{"option":option}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }